import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Notification from '../pages/Notification';
import SearchResult from '../pages/SearchResult';
import AllOrder from '../pages/AllOrder';
import HelpSupport from '../pages/HelpSupport';
import SupportChat from '../pages/SupportChat';
import OrderSummary from '../pages/OrderSummary';
import GroupOrder from '../pages/GroupOrder';
import GroupOrderGuest from '../pages/GroupOrderGuest';
import GroupOrderCheckout from '../pages/GroupOrderCheckout';
import RestaurantsDetails from '../pages/RestaurantsDetails';
import SavedAddresses from '../pages/SavedAddresses';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import FAQs from '../pages/FAQs';
import AboutUs from '../pages/AboutUs';
import RateUs from '../pages/RateUs';
import DiningDetails from '../pages/DiningDetails';
import PayBillDining from '../pages/PayBillDining';
import DiningHome from '../pages/DiningHome';

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-900">
    <div className="text-center">
      <h1 className="text-2xl font-semibold dark:text-white mb-2">404</h1>
      <p className="text-gray-500 dark:text-gray-400 mb-4">Page Not Found</p>
      <a href="/" className="text-[#7402A7] dark:text-purple-400">
        Go Home
      </a>
    </div>
  </div>
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/register" element={<Navigate to="/" replace />} />
      <Route path="/restaurants/:id" element={<RestaurantsDetails />} />
      <Route path="/notification" element={<Notification />} />
      <Route path="/result" element={<SearchResult />} />
      <Route path="/help-and-support" element={<HelpSupport />} />
      <Route path="/support/chat" element={<SupportChat />} />
      <Route path="/orders" element={<AllOrder />} />
      <Route path="/orders/:id" element={<AllOrder />} />
      <Route path="/order-summary" element={<OrderSummary />} />
      <Route path="/cart" element={<Navigate to="/order-summary" replace />} />
      <Route path="/checkout" element={<Navigate to="/order-summary" replace />} />
      <Route path="/group-order" element={<GroupOrder />} />
      <Route path="/group-order/:sessionId" element={<GroupOrder />} />
      <Route path="/group-order-guest" element={<GroupOrderGuest />} />
      <Route path="/group-order-join/:inviteToken" element={<GroupOrderGuest />} />
      <Route path="/group-order-checkout/:sessionId" element={<GroupOrderCheckout />} />
      <Route path="/saved-addresses" element={<SavedAddresses />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/rate-us" element={<RateUs />} />
      <Route path="/dining" element={<DiningHome />} />
      <Route path="/dining/restaurants" element={<DiningHome />} />
      <Route path="/dining/restaurants/:id" element={<DiningDetails />} />
      <Route path="/dining/pay-bill/:id" element={<PayBillDining />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
